import script from "./DiamondCertificate.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiamondCertificate.vue?vue&type=script&lang=ts&setup=true"

import "./DiamondCertificate.vue?vue&type=style&index=0&id=05531926&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05531926"]])

export default __exports__